import './unauthorized.scss';
import Button from '@paycor/picl/button';
import { useHistory } from 'react-router-dom';

export default function Unauthorized() {
    const history = useHistory() as { push: (url: string) => void };

    return (
        <div className="unauthorized-container">
            <h1 className="unauthorized-title">Forbidden</h1>
            <div className="unauthorized-error-message" data-testid="unauthorized-error-message">
                You are not authorized to access this page.
            </div>
            <Button
                type="secondary"
                onClick={() => {
                    history.push(`/`);
                }}
            >
                Return to My Paths
            </Button>
        </div>
    );
}
